<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-bottom:20px;">About the Author</h1>
<p>D.L. Klason is an award-winning Australian author and amateur historian specialising in premodern Japanese history. With master’s degrees in both Research and International Relations, he has combined his love of research and detail to provide his readership with an exciting insight into the events and characters of this important but turbulent era.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?8b2f4f14